export default {
    render(c) {
      return c("router-view");
    },
  };
